/**
 *@author: Sirisha.M
 *@Description : This component is mainly for manager actions
 **/
/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import {
  Button,
  Input,
  Tabs,
  Form,
  Select,
  message,
  Modal,
  Tooltip,
  Space,
  Row,
  Col,
  DatePicker,
  Upload,
  Collapse,
  Drawer,
  Popconfirm,
  Checkbox
} from 'antd';
import HierarchyModal from './HierarchyModal';
import StyledTable from '../../../commons/styles/table';

import {
  getHierarchyTreeData,
  getAllAnalysisById,
  onManagerSubmit,
  getDeviceList,
  getUserHeirarchyData,
  getDepartmentList,
  getSeverityList,
  getFailureList,
  getUserList,
  getStatusList,
  getHistoryList,
  getFailureCodeList,
  DeleteAttachment,
  getQuestionsList,
  getUsersList,
  getAnalysisByIdMultiple,
  getCorrectiveByIdMultiple
} from './ChartCalls';
import dayjs from 'dayjs';
// import Highlighter from 'react-highlight-words';
import localStorage from '../../../utils/localStorage';
import Highlighter from 'react-highlight-words';
// import { StyledTable } from './style';

import {
  SearchOutlined,
  UpSquareOutlined,
  UpOutlined,
  DownOutlined,
  CloudUploadOutlined,
  DownloadOutlined,
  EditOutlined,
  PlusOutlined,
  EyeOutlined,
  MinusCircleOutlined,
  QuestionCircleOutlined,
  DeleteOutlined,
  RollbackOutlined,
  UploadOutlined
} from '@ant-design/icons';
import TextArea from 'antd/es/input/TextArea';
import themeSettings from '../../../commons/styles/themeSettings.json';

// import { translation } from '../../commons/translation';
import '../style.css';
import { API_FRACAS, API_FRACAS_MULTIPLE, IPAddress } from '../../../commons/api';
// import { QuestionCircleOutlined } from '@ant-design/icons';
const { TabPane } = Tabs;
const { Option } = Select;
const { Panel } = Collapse;

const ManagerActions = (props) => {
  const [presentActiveKey, setPresentActiveKey] = useState(props.presentActiveKey || 'List');

  const [formObject, setFormObject] = useState({});
  const [analysisFormObject, setAnalysisFormObject] = useState({});
  const [correctiveFormObject, setCorrectiveFormObject] = useState({
    CorrectiveActionsAttachments: {
      0: [], // attachments for corrective index 0
      1: [], // attachments for corrective index 1
      // ...
    }
  });

  const [searchedColumn, setSearchedColumn] = useState('');
  const [devicesList, setDevicesList] = useState([]);
  const [treeVisible, setTreeVisible] = useState(false);
  const [checkedValue, setCheckedValue] = useState(props.checkedValue || null);
  const [equipmentList, setEquipmentList] = useState([]);
  const [selectedDevice, setSelectedDevice] = useState(null);
  const [questionsList, setQuestionsList] = useState([]);
  const [Questions, setQuestions] = useState([]);
  // const [AnalysisValues, setAnalysisValues] = useState([]);
  const [AnalysisValues_M, setAnalysisValues_M] = useState([]);
  const [ExistingCorrective_M, setExistingCorrective_M] = useState([]);
  const [selectedCorrectiveActions, setSelectedCorrectiveActions] = useState([]);
  const [selectedAnalysisDetails, setSelectedAnalysisDetails] = useState([]);

  const [dataSourceForManager, setDataSourceForManager] = useState([]);
  const [FailureTypeList, setFailureTypeList] = useState([]);
  const [FailureCodeList, setFailureCodeList] = useState([]);
  const [Users, setUsers] = useState([]);
  const [SeverityList, setSeverityList] = useState([]);
  const [departmentList, setDepartmentList] = useState([]);
  const [usersList, setUsersList] = useState([]);
  const [userList, setUserList] = useState([]);
  const [failureTypeId, setFailureTypeId] = useState(null);
  const [showusecasedownloadModal, setShowusecasedownloadModal] = useState(false);
  const [analysisShowusecasedownloadModalExisting, setAnalysisShowusecasedownloadModalExisting] = useState(false);

  const [correctiveShowusecasedownloadModalExisting, setCorrectiveShowusecasedownloadModalExisting] = useState(false);

  const [userDepartmentId, setUserDepartmentId] = useState(null);
  // const [checked, setChecked] = useState(false);
  const [selectedKey, setSelectedKey] = useState('');
  const [statusList, setStatusList] = useState([]);
  const [status, setStatus] = useState(null);
  const [correctiveStatus, setCorrectiveStatus] = useState(null);
  const [correctiveButton, setCorrectiveButton] = useState(false);
  const [failureAnalysisText, setFailureAnalysisText] = useState('');
  const [current, setCurrent] = useState(props.current);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [selectedIndexAnalysis, setSelectedIndexAnalysis] = useState(null);
  const [selectedIndexEC, setSelectedIndexEC] = useState(null);
  const [selectedStatusId, setSelectedStatusId] = useState(null);



  const h2Ref = useRef(null);
  const CARef = useRef(null);

  const [form1] = Form.useForm();
  const [form3] = Form.useForm();
  const [form2] = Form.useForm();
  const [form4] = Form.useForm();
  const [form_Manager1] = Form.useForm();

  const [QuestionRef] = Form.useForm();
  const [DepartmentRef] = Form.useForm();
  const [DepartmentRef1] = Form.useForm();
  const [DepartmentRef2] = Form.useForm();
  const [AnalysisRef] = Form.useForm();
  const [AnalysisRef_M] = Form.useForm();
  const [ExistingCorrectiveRef] = Form.useForm();
  const [ExistingCorrectiveRef_M] = Form.useForm();

  const myRef = useRef(null);
  const myRef1 = useRef(null);
  const myRef2 = useRef(null);

  // const QuestionRef = useRef(null);

  const failureAnalysisInput = useRef(null);
  useEffect(() => {
    const fetchData = async () => {
      let devicesList = await getDeviceList();
      setDevicesList(devicesList);
      let HierarchyData = await getUserHeirarchyData();
      let DepartmentId =
        HierarchyData &&
        HierarchyData['user'] &&
        HierarchyData['user']['DepartmentId'];
      let dataSource = await getHistoryList(DepartmentId, props.screenName);
      setDataSourceForManager(dataSource);
    };
    fetchData();
  }, []);
  useEffect(() => {
    if (current !== props.current) {
      setCurrent(props.current);
    }
  }, [current, props.current]);
  useEffect(() => {

    if (presentActiveKey !== props.presentActiveKey) {
      setPresentActiveKey(props.presentActiveKey);
    }
  }, [presentActiveKey, props.presentActiveKey]);
  useEffect(() => {

    if (checkedValue !== props.checkedValue) {
      setCheckedValue(props.checkedValue);
    }
  }, [checkedValue, props.checkedValue]);

  const translation = (keyword) => {
    let { translationCache } = props;
    return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  };
  const onAttachmentDelete = async (e, record) => {
    // let response = await DeleteAttachment(record.Id);
    // message.success(response && response.message);
    const filteredAttachments = formObject && formObject.Attachments && formObject.Attachments.filter(item => item.Id !== record.Id);
    let data = {
      ...formObject,
      Attachments: filteredAttachments
    };
    setFormObject(data);
  };

  const disabledDate = (current) => {
    return current > dayjs().endOf('day');
  };
  const onStatusChange = (value) => {
    let selectedStatus = statusList && statusList.filter(item => item.NextStatus === value);
    setSelectedStatusId(selectedStatus && selectedStatus[0] && selectedStatus[0].Id);

    setStatus(value);
    if (value === 'Analysis Completed') {
      setCorrectiveButton(true);
    } else {
      setCorrectiveButton(false);
    }
  };
  const handleClick = (e) => {
    if (e === 'Add New Attachments') {
      myRef.current && myRef.current.click();
    } else {
      setShowusecasedownloadModal(true);
    }
  };
  const fileUpload = (info) => {
    if (info.file.status === 'done') {
      let id =
        info && info.file && info.file.response && info.file.response && info.file.response.Id;
      let Name =
        info && info.file && info.file.response && info.file.response && info.file.response.Name;
      if (formObject) {
        if (formObject['Attachments']) {
          formObject['Attachments'] =
            formObject && formObject['Attachments'] ? formObject['Attachments'] : [];

          formObject['Attachments'].push({ Id: id, file: Name });
        } else {
          formObject['Attachments'] = [];
          formObject['Attachments'].push({ Id: id, file: Name });
        }
      } else {
        if (formObject && formObject['Attachments'] && formObject['Attachments'].length !== 0) {
          formObject['Attachments'] =
            formObject && formObject['Attachments'] ? formObject['Attachments'] : [];
          formObject['Attachments'].push({ Id: id, file: Name });
        } else {
          formObject &&
            formObject['Attachments'] &&
            formObject['Attachments'].push({ Id: id, file: Name });
        }
      }

      setFormObject(formObject);
      // this.hForm.current.setFieldsValue(formObject);
      message.success(`${info.file.name} file uploaded successfully`);
    } else if (info.file.status === 'error') {
      message.error(`${info.file.name} file upload failed.`);
    }
  };
  //     const onChangeDepartment = async (value, rowIndex) => {
  //   const userList = await getUsersList(value);

  //   // Update specific users for that row index
  //   setUsersPerDepartment(prev => ({
  //     ...prev,
  //     [rowIndex]: userList
  //   }));

  //   const departments = DepartmentRef.current?.getFieldValue('Users') || [];
  //   departments[rowIndex] = {
  //     ...departments[rowIndex],
  //     UserId: null, // Reset User
  //     DepartmentId: value
  //   };
  //   DepartmentRef.current?.setFieldsValue({ Users: departments });
  // };

  const beforeUpload = (file) => {
    const reader = new FileReader();
    reader.onload = () => {
      this.setState({
        filename: file.name
      });
    };
  };
  const ResetFields = async () => {
    form1?.resetFields();
    form1?.setFieldsValue({
      ReportedDate: dayjs(),
      ReportedBy: props?.userProfile?.user?.FirstName,
      Status: "Open",
      // ...other defaults
    });

    let formData = {
      Device: null,
      Type: null,
      Equipment: null,
      FailureTypeId: null,
      FaultCode: null,
      FailureDescription: null,
      SeverityId: null,
      Impact: null,
      OccuranceDate: null,
      ReportedDate: dayjs(),
      OccuranceCount: null,
      Remarks: null,
      // Attachments: [],
      ReportedBy:
        props && props.userProfile && props.userProfile.user && props.userProfile.user.FirstName,
      Comments: null,
      Status: "Open",
      DepartmentId: null,
      UserId: null
    };
    QuestionRef?.setFieldsValue({
      Questions: []
    });
    DepartmentRef?.setFieldsValue({
      Users: []
    });
    form4?.setFieldsValue({
      Corrective: []
    });
    setUsers([]);
    setQuestions([]);
    setFormObject(formData);
    setSelectedDevice(null);
    let departmentList = await getDepartmentList();
    setDepartmentList(departmentList);
    setFailureCodeList([]);
    setUsersList([]);
    setStatus("Open");
  };
  const onCancel = () => {
    ResetFields();
    // analysisFormResetFields();
    // correctiveResetFields();
    setCorrectiveStatus(null);
    setCorrectiveButton(false);
    props.onActiveTabChange('List');
    // setPresentActiveKey('List');
    setCheckedValue(null);
  };
  const DeleteAttachmentFun = async (record) => {
    let response = await DeleteAttachment(record.Id);
    message.success(response && response.message);
    const filteredAttachments = formObject && formObject.Attachments && formObject.Attachments.filter(item => item.Id !== record.Id);
    let data = {
      ...formObject,
      Attachments: filteredAttachments
    };
    setFormObject(data);
  };


  const existingAnalysisHandleClick = (e, index) => {
    const rowKey = Array.isArray(index) ? index.join('-') : index;

    setSelectedIndexAnalysis(rowKey);
    if (e === 'Add New Attachments') {
      myRef1.current && myRef1.current.click();
    } else {
      setAnalysisShowusecasedownloadModalExisting(true);
    }
  };

  const onModalCancel = () => {
    if (selectedDevice && Array.isArray(selectedDevice) && selectedDevice.length > 0) {
      setCheckedValue(selectedDevice);
    } else {
      setCheckedValue(null);
    }

    setTreeVisible(false);
  };
  const hierarchyDropdownChange = async (value) => {
    setCheckedValue(value);
    let FailureCodeList = await getFailureCodeList(value);
    setFailureCodeList(FailureCodeList);
    setSelectedDevice(value);
    setFailureTypeId(null);
    setQuestionsList([]);
    setTreeVisible(false);
    form1?.setFieldsValue({
      Device: value,
      FailureTypeId: null,
      FaultCode: null
    });
    QuestionRef?.setFieldsValue({
      Questions: []
    });
    DepartmentRef?.setFieldsValue({
      Users: []
    });
    setUsers([]);
    setQuestions([]);
  };

  const correctiveFileUpload = (info, key, index) => {
    const rowKey = Array.isArray(index) ? index.join('-') : index;
    if (info.file.status === 'done') {
      let id = info?.file?.response?.Id;
      let Name = info?.file?.response?.Name;

      setCorrectiveFormObject((prev) => {
        const attachments = prev && prev.CorrectiveActionsAttachments || {};
        const currentAttachments = attachments[rowKey] || [];

        return {
          ...prev,
          CorrectiveActionsAttachments: {
            ...attachments,
            [rowKey]: [...currentAttachments, { Id: id, file: Name }]
          }
        };
      });

      message.success(`${info.file.name} file uploaded successfully`);
    } else if (info.file.status === 'error') {
      message.error(`${info.file.name} file upload failed.`);
    }
  };
  const analysisResetFields = () => {
    form2?.setFieldsValue({
      Type: null,
      Equipment: null,
      FailureTypeId: null,
      FaultCode: null,
      FailureDescription: null,
      SeverityId: null,
      Impact: null,
      OccuranceDate: null,
      OccuranceCount: null,
      Remarks: null,
      ReportedDate: dayjs(),
      // Attachments: [],
      ReportedBy:
        props && props.userProfile && props.userProfile.user && props.userProfile.user.FirstName,
      Comments: null,
      Status: null,
      UserId: null,
      DepartmentId: null
    });
    let formData = {
      Type: null,
      Equipment: null,
      FailureTypeId: null,
      FaultCode: null,
      FailureDescription: null,
      SeverityId: null,
      Impact: null,
      OccuranceDate: null,
      ReportedDate: dayjs(),
      OccuranceCount: null,
      Remarks: null,
      // Attachments: [],
      ReportedBy:
        props && props.userProfile && props.userProfile.user && props.userProfile.user.FirstName,
      Comments: null,
      Status: null,
      DepartmentId: null,
      UserId: null
    };
    QuestionRef?.setFieldsValue({
      Questions: []
    });
    DepartmentRef1?.setFieldsValue({
      Users: []
    });
    form4?.setFieldsValue({
      Corrective: []
    });
    ExistingCorrectiveRef?.setFieldsValue({
      ExistingCorrective: []
    });
    AnalysisRef?.setFieldsValue({
      AnalysisValues: []
    });
    // setUsers([]);
    // setExistingCorrective([]);
    setQuestions([]);
    setFormObject(formData);
    setSelectedDevice(null);
  };
  const correctiveResetFields = () => {
    form4?.setFieldsValue({
      Corrective: []
    });
    ExistingCorrectiveRef?.setFieldsValue({
      ExistingCorrective: []
    });
    setCorrectiveFormObject({});
    setCorrectiveButton(false);
    setCorrectiveStatus(null);
  };
  const onAnalysisAttachmentDelete = async (e, record) => {
    // let response = await DeleteAttachment(record.Id);
    // message.success(response && response.message);
    const filteredAttachments = analysisFormObject && analysisFormObject.AnalysisAttachments && analysisFormObject.AnalysisAttachments.filter(item => item.Id !== record.Id);
    let data = {
      ...analysisFormObject,
      AnalysisAttachments: filteredAttachments
    };
    setAnalysisFormObject(data);
  };
  const onCorrectiveAttachmentDelete = async (e, record) => {
    // let response = await DeleteAttachment(record.Id);
    // message.success(response && response.message);
    const filteredAttachments = correctiveFormObject && correctiveFormObject.CorrectiveActionsAttachments && correctiveFormObject.CorrectiveActionsAttachments.filter(item => item.Id !== record.Id);
    let data = {
      ...correctiveFormObject,
      CorrectiveActionsAttachments: filteredAttachments
    };
    setCorrectiveFormObject(data);
  };
  const existingCorrectiveHandleClick = (e, index) => {
    const rowKey = Array.isArray(index) ? index.join('-') : index;

    setSelectedIndexEC(rowKey);
    if (e === 'Add New Attachments') {
      myRef2.current && myRef2.current.click();
    } else {
      setCorrectiveShowusecasedownloadModalExisting(true);
    }
  };

  const analysisFileUpload = (info) => {
    if (info.file.status === 'done') {
      let id =
        info && info.file && info.file.response && info.file.response && info.file.response.Id;
      let Name =
        info && info.file && info.file.response && info.file.response && info.file.response.Name;
      if (analysisFormObject) {
        if (analysisFormObject['AnalysisAttachments']) {
          analysisFormObject['AnalysisAttachments'] =
            analysisFormObject && analysisFormObject['AnalysisAttachments'] ? analysisFormObject['AnalysisAttachments'] : [];

          analysisFormObject['AnalysisAttachments'].push({ Id: id, file: Name });
        } else {
          analysisFormObject['AnalysisAttachments'] = [];
          analysisFormObject['AnalysisAttachments'].push({ Id: id, file: Name });
        }
      } else {
        if (analysisFormObject && analysisFormObject['AnalysisAttachments'] && analysisFormObject['AnalysisAttachments'].length !== 0) {
          analysisFormObject['AnalysisAttachments'] =
            analysisFormObject && analysisFormObject['AnalysisAttachments'] ? analysisFormObject['AnalysisAttachments'] : [];
          analysisFormObject['AnalysisAttachments'].push({ Id: id, file: Name });
        } else {
          analysisFormObject &&
            analysisFormObject['AnalysisAttachments'] &&
            analysisFormObject['AnalysisAttachments'].push({ Id: id, file: Name });
        }
      }

      setAnalysisFormObject(analysisFormObject);
      // this.hForm.current.setFieldsValue(formObject);
      message.success(`${info.file.name} file uploaded successfully`);
    } else if (info.file.status === 'error') {
      message.error(`${info.file.name} file upload failed.`);
    }
  };

  const disabledEndDate = (current) => {
    const startDate = form3?.getFieldValue?.('AnalysisStartDate');
    if (!startDate) {
      // If no start date selected, allow all dates
      return false;
    }
    // Disable dates before the selected start date
    return current && current.isBefore(dayjs(startDate), 'day');
  };
  const AnalysisDeleteAttachmentFun = async (record) => {
    let response = await DeleteAttachment(record.Id);
    message.success(response && response.message);
    const filteredAttachments = analysisFormObject && analysisFormObject.AnalysisAttachments && analysisFormObject.AnalysisAttachments.filter(item => item.Id !== record.Id);
    let data = {
      ...analysisFormObject,
      AnalysisAttachments: filteredAttachments
    };
    setAnalysisFormObject(data);
  };
  const CorrectiveDeleteAttachmentFun = async (record) => {
    let response = await DeleteAttachment(record.Id);
    message.success(response && response.message);
    const filteredAttachments = correctiveFormObject && correctiveFormObject.CorrectiveActionsAttachments && correctiveFormObject.CorrectiveActionsAttachments.filter(item => item.Id !== record.Id);
    let data = {
      ...correctiveFormObject,
      CorrectiveActionsAttachments: filteredAttachments
    };
    setCorrectiveFormObject(data);
  };

  const onManagerFormSubmit = async () => {
    const values = await form_Manager1?.getFieldsValue();
    if ((selectedAnalysisDetails && Array.isArray(selectedAnalysisDetails) && selectedAnalysisDetails.length > 0)
      ||
      (selectedCorrectiveActions && Array.isArray(selectedCorrectiveActions) && selectedCorrectiveActions.length > 0)) {

      let payload = {
        Analysis: selectedAnalysisDetails,
        CorrectiveActions: selectedCorrectiveActions,
        Remarks: values.Remarks || null
      };
      let response = await onManagerSubmit(payload);
      if (response && response.status && response.status === 200) {
        message.success(response.data && response.data.message);
        ResetFields();
        analysisResetFields();
        correctiveResetFields();
        props.onActiveTabChange('List');
        // setPresentActiveKey('List');
        let data = await getHistoryList(userDepartmentId, props.screenName);
        setDataSourceForManager(data);
      } else {
        message.error(response.data && response.data.message);

      }

    } else {
      message.warning('Please select atleast one option to submit!');
    }
  };
  const onCheckChange = (e, key, name) => {
    const isChecked = e.target.checked;

    const selectedCorrective = ExistingCorrective_M?.[name];
    if (!selectedCorrective) {
      console.warn('No corrective action found for:', name);
      return;
    }

    const selectedCorrectiveObj = {
      Id: selectedCorrective.Id,
      ReportId: selectedCorrective.ReportId,
      Selected: isChecked,
    };

    let updatedArray = [...selectedCorrectiveActions];

    const existingIndex = updatedArray.findIndex(item => item.Id === selectedCorrectiveObj.Id);

    if (existingIndex !== -1) {
      if (isChecked) {
        // Update existing item
        updatedArray[existingIndex] = selectedCorrectiveObj;
      } else {
        // Remove if unchecked
        updatedArray.splice(existingIndex, 1);
      }
    } else if (isChecked) {
      // Add new item if checked
      updatedArray.push(selectedCorrectiveObj);
    }
    const selectedItems = updatedArray.filter(item => item.Selected === true);
    setSelectedCorrectiveActions(selectedItems);
  };
  const onAnalysisCheckChange = (e, key, name) => {
    const isChecked = e.target.checked;

    const selectedAnalysis = AnalysisValues_M?.[name];
    if (!selectedAnalysis) {
      console.warn('No corrective action found for:', name);
      return;
    }

    const selectedAnalysisObj = {
      Id: selectedAnalysis.Id,
      ReportId: selectedAnalysis.ReportId,
      Selected: isChecked,
    };

    let updatedArray = [...selectedAnalysisDetails];

    const existingIndex = updatedArray.findIndex(item => item.Id === selectedAnalysisObj.Id);

    if (existingIndex !== -1) {
      if (isChecked) {
        // Update existing item
        updatedArray[existingIndex] = selectedAnalysisObj;
      } else {
        // Remove if unchecked
        updatedArray.splice(existingIndex, 1);
      }
    } else if (isChecked) {
      //  Add new item if checked
      updatedArray.push(selectedAnalysisObj);
    }

    const selectedItems = updatedArray.filter(item => item.Selected === true);
    setSelectedAnalysisDetails(selectedItems);
  };
  const getColumnSearchPropsFailureAnalysisForManager = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        {dataIndex === 'OccuranceDate' || dataIndex === 'ReportedDate' ? (
          <DatePicker
            showTime={{ format: 'HH:mm' }}
            format="YYYY-MM-DD HH:mm"
            placeholder={`Search ${dataIndex}`}
            value={selectedKeys[0] ? dayjs(selectedKeys[0], 'YYYY-MM-DD HH:mm') : null}
            onChange={(value) =>
              setSelectedKeys(value ? [value.format('YYYY-MM-DD HH:mm')] : [])
            }
            onPressEnter={() => handleSearchFailureAnalysisForManager(selectedKeys, confirm, dataIndex)}
            style={{ width: 188, marginBottom: 8, display: 'block' }}
          />
        ) : (
          <Input
            ref={failureAnalysisInput}
            placeholder={`Search ${dataIndex}`}
            value={selectedKeys[0]}
            onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
            onPressEnter={() => handleSearchFailureAnalysisForManager(selectedKeys, confirm, dataIndex)}
            style={{ width: 188, marginBottom: 8, display: 'block' }}
          />
        )}
        <Button
          type="primary"
          onClick={() => handleSearchFailureAnalysisForManager(selectedKeys, confirm, dataIndex)}
          icon={<SearchOutlined />}
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button
          onClick={() => handleResetFailureAnalysisForManager(clearFilters, confirm, dataIndex)}
          style={{ width: 90 }}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) => {
      if (!record || !record[dataIndex]) return false;
      if (dataIndex === 'OccuranceDate ' || dataIndex === 'ReportedDate') {
        // Compare full date and time string
        return dayjs(record[dataIndex]).format('YYYY-MM-DD HH:mm') === value;
      }
      return record[dataIndex].toString().toLowerCase().includes(value.toLowerCase());
    },
    render: (text) =>
      dataIndex === 'OccuranceDate' || dataIndex === 'ReportedDate'
        ? text
          ? moment(text).format('YYYY-MM-DD HH:mm')
          : null
        : (
          <Highlighter
            highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
            searchWords={failureAnalysisText[dataIndex] ? [failureAnalysisText[dataIndex]] : []}
            autoEscape
            textToHighlight={text ? text.toString() : ''}
          />
        ),
  });

  const handleSearchFailureAnalysisForManager = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchedColumn(dataIndex);
    setFailureAnalysisText(prev => ({
      ...prev,
      [dataIndex]: selectedKeys[0] || ''
    }));
  };
  const handleResetFailureAnalysisForManager = (clearFilters, confirm, dataIndex) => {
    clearFilters();
    setSearchedColumn('');
    confirm();
    setFailureAnalysisText(prev => ({
      ...prev,
      [dataIndex]: ''
    }));
  };
  const managerEdit = async (record, key) => {
    props.onActiveTabChange('Details');
    // setPresentActiveKey('Details');
    setSelectedKey(key);
    let HierarchyData = await getUserHeirarchyData();

    let permissionsArray =
      HierarchyData &&
      HierarchyData['belongsTo'] &&
      HierarchyData['belongsTo']['sites'] &&
      HierarchyData['belongsTo']['sites'][localStorage.get('currentSite')] &&
      HierarchyData['belongsTo']['sites'][localStorage.get('currentSite')]['hierarchy'];

    let DepartmentId =
      HierarchyData &&
      HierarchyData['user'] &&
      HierarchyData['user']['DepartmentId'];
    setUserDepartmentId(DepartmentId);
    const EquipmentList = await getHierarchyTreeData(
      permissionsArray && permissionsArray[0] && permissionsArray[0].HierarchyName
    );

    setEquipmentList(EquipmentList);
    // setDataSource(data);
    let FailureTypeList = await getFailureList();
    setFailureTypeList(FailureTypeList);
    let SeverityList = await getSeverityList();
    setSeverityList(SeverityList);
    let departmentList = await getDepartmentList();
    setDepartmentList(departmentList);

    try {
      // const LoginUser = props?.userProfile?.user?.Id;

      const [userList, statusList, editedRow] = await Promise.all([
        getUserList(),
        getStatusList(record.Status),
        getAnalysisByIdMultiple(record.Id, 'Analysis and Corrective Actions'),
      ]);

      setUserList(userList);
      setStatusList(statusList);
      // let selectedStatusId = statusList && statusList.filter(item=>item.NextStatus === record.Status);
      //   setSelectedStatusId(selectedStatusId);
      const AnalysisDetails = await getAllAnalysisById(record.Id);
      const otherUsers = AnalysisDetails;
      const transformedAnalysisData = otherUsers && otherUsers.map(item => ({
        Id: item.Id,
        ReportId: item.ReportId,
        Selected: item.Selected
      }));
      setSelectedAnalysisDetails(transformedAnalysisData);
      const otherAnalysisUsers = otherUsers.map(user => ({
        ...user,
        AnalysisStartDate: dayjs(user.AnalysisStartDate),
        AnalysisDueDate: dayjs(user.AnalysisDueDate),
      }));

      const correctiveEdit = await getCorrectiveByIdMultiple(record.Id);
      const otherCorrective = correctiveEdit;


      const transformedData = otherCorrective && otherCorrective.map(item => ({
        Id: item.Id,
        ReportId: item.ReportId,
        Selected: item.Selected
      }));
      setSelectedCorrectiveActions(transformedData);
      if (otherCorrective.length > 0) {
        const otherCorrectiveMapped = otherCorrective.map(item => ({
          ...item,
          CorrectiveActionsAttachments: item.CorrectiveActionsAttachments || [],
        }));
        ExistingCorrectiveRef_M?.setFieldsValue({ ExistingCorrective_M: otherCorrectiveMapped });
        setExistingCorrective_M(otherCorrectiveMapped);
      } else {
        ExistingCorrectiveRef_M?.setFieldsValue({ ExistingCorrective_M: [] });
        setExistingCorrective_M([]);
      }

      if (!editedRow) {
        console.error('No record found');
        return;
      }

      const failureCodeList = await getFailureCodeList(editedRow.Device);
      setFailureCodeList(failureCodeList);

      const assignUsers = editedRow.AssignUsers || [];
      const departmentIds = [...new Set(assignUsers.map(u => u.DepartmentId))];
      const allDeptUsers = [];

      for (const deptId of departmentIds) {
        const users = await getUsersList(deptId);
        if (Array.isArray(users)) {
          allDeptUsers.push(...users);
        }
      }

      setUsersList(allDeptUsers);
      setSelectedDevice(editedRow.Device);
      setFailureTypeId(editedRow.FailureTypeId);

      const questionsList = await getQuestionsList(editedRow.FailureTypeId, editedRow.Device);
      setQuestionsList(questionsList);

      const formValues = {
        ...editedRow,
        Id: editedRow.ReportId,
        OccuranceDate: dayjs(editedRow.OccuranceDate).utc(),
        ReportedDate: dayjs(editedRow.ReportedDate),
        ReportedBy: editedRow.ReportedName,
        ReportID: editedRow.ReportIds,
        Status: editedRow.FracasStatus
      };

      await form_Manager1?.setFieldsValue(formValues);
      setFormObject(formValues);

      if (otherAnalysisUsers.length > 0) {
        AnalysisRef_M?.setFieldsValue({ AnalysisValues_M: otherAnalysisUsers });
        setAnalysisValues_M(otherAnalysisUsers);
      } else {
        AnalysisRef_M?.setFieldsValue({ AnalysisValues_M: [] });
        setAnalysisValues_M([]);
      }

      if (editedRow.FracasStatus === 'Analysis Completed') {
        setCorrectiveButton(true);
      }

      setStatus(editedRow.FracasStatus);
      DepartmentRef2?.setFieldsValue({
        Users: assignUsers,
      });

      setUsers(assignUsers);

      await QuestionRef?.setFieldsValue({
        Questions: editedRow.Questions,
      });

      setQuestions(editedRow.Questions);
    } catch (error) {
      console.error('Error editing record:', error);
    }
  };
  const UseCaseColumns = [
    {
      title: translation('File'),
      dataIndex: 'file',
      key: 'file',
      align: 'center'
    },
    {
      title: translation('Action'),
      width: '600',
      align: 'center',
      render: (text, record) => (
        <div style={{ display: 'flex', flexWrap: 'wrap' }}>
          <>
            <Tooltip placement="top" key="download" title="Download">
              <div>
                <a href={`${IPAddress.LOCAL}${API_FRACAS.FracasAttachments}/${record.file}`}>
                  {' '}
                  <DownloadOutlined style={{ color: '#1a91ff' }} />
                </a>
              </div>
            </Tooltip>
          </>
          {selectedKey !== 'view' && (
            record && !record.ReportId ? (
              <Popconfirm
                title={translation("Are you sure that you want to delete the file")}
                icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                onConfirm={(e) => onAttachmentDelete(e, record)}
                okText={translation('Yes')}
                cancelText={translation('No')}
              >
                <div style={{ marginLeft: '15px' }}>
                  <Tooltip title={translation('Delete')}>
                    <DeleteOutlined />
                  </Tooltip>
                </div>
              </Popconfirm>
            ) : (
              <Popconfirm
                title={translation("Are you sure that you want to delete the file")}
                icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                onConfirm={() => DeleteAttachmentFun(record)}
                okText={translation('Yes')}
                cancelText={translation('No')}
              >
                <div style={{ marginLeft: '15px' }}>
                  <Tooltip title={translation('Delete')}>
                    <DeleteOutlined />
                  </Tooltip>
                </div>
              </Popconfirm>
            )
          )}
        </div>
      )
    }
  ];
  const AnalysisUseCaseColumns = [
    {
      title: translation('File'),
      dataIndex: 'file',
      key: 'file',
      align: 'center'
    },
    {
      title: translation('Action'),
      width: '600',
      align: 'center',
      render: (text, record) => (

        <div style={{ display: 'flex', flexWrap: 'wrap' }}>
          <>
            <Tooltip placement="top" key="download" title="Download">
              <div>
                <a href={`${IPAddress.LOCAL}${API_FRACAS.FracasAttachments}/${record.file}`}>
                  {' '}
                  <DownloadOutlined style={{ color: '#1a91ff' }} />
                </a>
              </div>
            </Tooltip>
          </>
          {selectedKey !== 'view' && (
            record && !record.ReportId ? (
              <Popconfirm
                title={translation("Are you sure that you want to delete the file")}
                icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                onConfirm={(e) => onAnalysisAttachmentDelete(e, record)}
                okText={translation('Yes')}
                cancelText={translation('No')}
              >
                <div style={{ marginLeft: '15px' }}>
                  <Tooltip title={translation('Delete')}>
                    <DeleteOutlined />
                  </Tooltip>
                </div>
              </Popconfirm>
            ) : (
              <Popconfirm
                title={translation("Are you sure that you want to delete the file")}
                icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                onConfirm={() => AnalysisDeleteAttachmentFun(record)}
                okText={translation('Yes')}
                cancelText={translation('No')}
              >
                <div style={{ marginLeft: '15px' }}>
                  <Tooltip title={translation('Delete')}>
                    <DeleteOutlined />
                  </Tooltip>
                </div>
              </Popconfirm>
            )
          )}
        </div>
      )
    }
  ];
  const CorrectiveActionsUseCaseColumns = [
    {
      title: translation('File'),
      dataIndex: 'file',
      key: 'file',
      align: 'center'
    },
    {
      title: translation('Action'),
      width: '600',
      align: 'center',
      render: (text, record) => (
        <div style={{ display: 'flex', flexWrap: 'wrap' }}>
          <>
            <Tooltip placement="top" key="download" title="Download">
              <div>
                <a href={`${IPAddress.LOCAL}${API_FRACAS.FracasAttachments}/${record.file}`}>
                  {' '}
                  <DownloadOutlined style={{ color: '#1a91ff' }} />
                </a>
              </div>
            </Tooltip>
          </>
          {selectedKey !== 'view' && (
            record && !record.ReportId ? (
              <Popconfirm
                title={translation("Are you sure that you want to delete the file")}
                icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                onConfirm={(e) => onCorrectiveAttachmentDelete(e, record)}
                okText={translation('Yes')}
                cancelText={translation('No')}
              >
                <div style={{ marginLeft: '15px' }}>
                  <Tooltip title={translation('Delete')}>
                    <DeleteOutlined />
                  </Tooltip>
                </div>
              </Popconfirm>
            ) : (
              <Popconfirm
                title={translation("Are you sure that you want to delete the file")}
                icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                onConfirm={() => CorrectiveDeleteAttachmentFun(record)}
                okText={translation('Yes')}
                cancelText={translation('No')}
              >
                <div style={{ marginLeft: '15px' }}>
                  <Tooltip title={translation('Delete')}>
                    <DeleteOutlined />
                  </Tooltip>
                </div>
              </Popconfirm>
            )
          )}
        </div>
      )
    }
  ];
  const FailureAnalysisForManagerColumns = [
    {
      title: translation('ReportID'),
      dataIndex: 'ReportId',
      key: 'ReportId',
      ...getColumnSearchPropsFailureAnalysisForManager('ReportId')
    },
    {
      title: translation('Equipment'),
      dataIndex: 'EquipmentCode',
      key: 'EquipmentCode',
      ...getColumnSearchPropsFailureAnalysisForManager('EquipmentCode')
    },
    {
      title: translation('Failure Type'),
      dataIndex: 'FailureTypeName',
      key: 'FailureTypeName',
      ...getColumnSearchPropsFailureAnalysisForManager('FailureTypeName')
    },
    {
      title: translation('Severity'),
      dataIndex: 'SeverityName',
      key: 'SeverityName',
      ...getColumnSearchPropsFailureAnalysisForManager('SeverityName')
    },
    {
      title: translation('Detection Source'),
      dataIndex: 'DetectionSource',
      key: 'DetectionSource',
      ...getColumnSearchPropsFailureAnalysisForManager('DetectionSource')
    },
    {
      title: translation('Occurred Date&Time'),
      dataIndex: 'OccuranceDate',
      key: 'OccuranceDate',
      sorter: (a, b) => dayjs(a.OccuranceDate) - dayjs(b.OccuranceDate),
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchPropsFailureAnalysisForManager('OccuranceDate'),
      render: (text) => {
        return {
          children:
            text !== undefined && text !== null ? (
              <div>{dayjs(text).utc().format('YYYY-MM-DD HH:mm')}</div>
            ) : null
        };
      }
    },
    {
      title: translation('Status'),
      dataIndex: 'Status',
      key: 'Status',
      ...getColumnSearchPropsFailureAnalysisForManager('Status')
    },
    {
      title: translation('Actions'),
      width: '600',
      render: (text, record) => (
        <>
          {record.Status === 'Closed'
            || record.Status === 'Open'
            || record.Status === 'Assigned'
            || record.Status === 'Under Analysis'
            || record.Status === 'Analysis Completed'
            || record.Status === 'Analysis to be reviewed'
            || record.Status === 'Reassign'
            || record.Status === 'Reject'
            || record.Status === 'On hold'
            // || record.Status === 'Reassign'
            // || record.Status === 'Analysis to be reviewed'
            ?
            <>
              <Button type="primary" onClick={() => managerEdit(record, 'view')}>
                <Tooltip title={translation('View')}>
                  <EyeOutlined />
                </Tooltip>
              </Button>
            </>
            :
            <>
              <Button type="primary" onClick={() => managerEdit(record, 'edit')}>
                <Tooltip title={translation('Edit')}>
                  <EditOutlined />
                </Tooltip>
              </Button>
            </>
          }
        </>
      )
    }
  ];
  const formItemLayout = { width: '100%', flex: '50%' };
  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');
  var Authorization = 'Bearer ' + token;

  return (
    <div>
      <Tabs
        type={'card'}
        defaultActiveKey="List"
        activeKey={presentActiveKey}
      >
        <TabPane tab={'List'} key="List">

          <StyledTable
            size="small"
            columns={FailureAnalysisForManagerColumns}
            dataSource={dataSourceForManager}
            style={{ marginTop: '24px' }}
            pagination={{
              current,
              onChange: (page) => setCurrent(page),
            }}
            onChange={props.handleTableChange}
          />
        </TabPane>
        <TabPane tab={'Details'} key="Details">
          <div style={{ padding: '10px 0px' }}>
            <div style={{ cursor: 'pointer' }}>
              <Button type='primary' style={{ cursor: 'pointer' }}
                onClick={() => props.onActiveTabChange('List')}
              >
                <RollbackOutlined />
                {translation('Go Back')}
              </Button>
            </div>
          </div>
          <Form
            name="FailureReport_Analysis"
            ref={h2Ref}
            form={form_Manager1}
            autoComplete="off"
            initialValues={formObject}
            layout="vertical"
            onFinish={onManagerFormSubmit}
            // onFinishFailed={onAnalysisFinishFailed}
            labelWrap
          >
            <div
              style={{ display: 'flex', flexWrap: 'wrap', marginTop: '10px' }}
            >
              <Collapse
                defaultActiveKey={['1']}
                style={{ width: '100%' }}
                expandIcon={({ isActive }) =>
                  isActive ? <UpOutlined /> : <DownOutlined />
                }
              >
                <Panel header="Reporting Details" key="1">

                  <div >
                    <Row gutter={16}>
                      <Form.Item name="Id"></Form.Item>

                      <Col xs={24} sm={12} md={12} lg={6} xl={6} xxl={6}>
                        <Form.Item
                          name="Device"
                          label={translation(`Equipment`)}
                          rules={[{ required: true, message: translation("Please Select Equipment!") }]}
                        >
                          <div style={{ display: 'flex', gap: '1%', flexWrap: 'wrap', width: '100%' }}>
                            <Select
                              style={{ flex: 1 }}
                              value={selectedDevice}
                              placeholder={translation('Select Equipment')}
                              disabled={true}
                            >
                              {devicesList?.map((eqp, index) => (
                                <Option key={index} value={eqp.AliasCode}>
                                  {`${eqp.DisplayCode}`}
                                </Option>
                              ))}
                            </Select>
                            <Button
                              type="primary"
                              onClick={() => setTreeVisible(true)}
                              disabled={formObject.Id}
                            >
                              <UpSquareOutlined />
                            </Button>
                          </div>
                        </Form.Item>
                      </Col>

                      <Col xs={24} sm={12} md={12} lg={6} xl={6} xxl={6}>
                        <Form.Item
                          label={translation('Failure Type')}
                          name="FailureTypeId"
                          rules={[{ required: true, message: translation("Please Select Failure Type!") }]}
                        >
                          <Select
                            disabled={formObject.Id}
                            placeholder={translation('Select Failure Type')}
                            style={{ width: '100%' }}
                          >
                            {FailureTypeList?.map((device, index) => (
                              <Option key={index} value={device.Id}>
                                {device.Name}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </Col>

                      <Col xs={24} sm={12} md={12} lg={6} xl={6} xxl={6}>
                        <Form.Item
                          label={translation('Fault Code')}
                          name="FaultCode"
                          rules={[{ required: true, message: translation("Please Select Fault Code!") }]}
                        >
                          <Select
                            disabled={formObject.Id}
                            placeholder={translation('Select Fault Code')}
                            style={{ width: '100%' }}
                          >
                            {FailureCodeList?.map((FailureCode, index) => (
                              <Option key={index} value={FailureCode.VendorCode}>
                                {FailureCode.ParameterDescription}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </Col>

                      <Col xs={24} sm={12} md={12} lg={6} xl={6} xxl={6}>
                        <Form.Item
                          label={translation('Severity')}
                          name="SeverityId"
                          rules={[{ required: true, message: translation("Please Select Severity!") }]}
                        >
                          <Select
                            disabled={formObject.Id}
                            placeholder={translation('Select Severity')}
                            style={{ width: '100%' }}
                          >
                            {SeverityList?.map((device, index) => (
                              <Option key={index} value={device.Id}>
                                {device.Name}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </Col>

                      <Col xs={24} sm={12} md={12} lg={6} xl={6} xxl={6}>
                        <Form.Item
                          label={translation('Failure Occurred Date&Time')}
                          name="OccuranceDate"
                          rules={[{ required: true, message: translation("Please Select Failure Occurred Date&Time!") }]}
                        >
                          <DatePicker
                            showTime={{ format: 'HH:mm' }}
                            placeholder="Select Occurance Date"
                            inputReadOnly={true}
                            style={{ width: '100%' }}
                            format="YYYY-MM-DD HH:mm"
                            disabledDate={disabledDate}
                            disabled={formObject.Id}
                          />
                        </Form.Item>
                      </Col>

                      <Col xs={24} sm={12} md={12} lg={6} xl={6} xxl={6}>
                        <Form.Item
                          label={translation('Failure Occurrence Count')}
                          name="OccuranceCount"
                          rules={[{ required: true, message: translation("Please input Failure Occurrence Count!") }]}
                        >
                          <Input
                            type="number"
                            onKeyDown={(e) => {
                              if ([8].includes(e.keyCode)) return;
                              if ((e.shiftKey || e.keyCode < 48 || e.keyCode > 57) && (e.keyCode < 96 || e.keyCode > 105)) {
                                e.preventDefault();
                              }
                            }}
                            placeholder={translation('Failure Occurrence Count')}
                            style={{ width: '100%' }}
                            disabled={formObject.Id}
                          />
                        </Form.Item>
                      </Col>

                      <Col xs={24} sm={12} md={12} lg={6} xl={6} xxl={6}>
                        <Form.Item
                          label={translation('Failure Description')}
                          name="FailureDescription"
                        >
                          <TextArea
                            placeholder={translation('Failure Description')}
                            style={{ width: '100%' }}
                            disabled={formObject.Id}
                          />
                        </Form.Item>
                      </Col>

                      <Col xs={24} sm={12} md={12} lg={6} xl={6} xxl={6}>
                        <Form.Item
                          label={translation('Failure Impact')}
                          name="Impact"
                        >
                          <TextArea
                            placeholder={translation('Add Failure Impact')}
                            style={{ width: '100%' }}
                            disabled={formObject.Id}
                          />
                        </Form.Item>
                      </Col>

                      <Col xs={24} sm={12} md={12} lg={6} xl={6} xxl={6}>
                        <Form.Item
                          label={translation('Comments')}
                          name="Comments"
                        >
                          <TextArea
                            placeholder={translation('Add Comments')}
                            style={{ width: '100%' }}
                            disabled={formObject.Id}
                          />
                        </Form.Item>
                      </Col>

                      <Col xs={24} sm={12} md={12} lg={6} xl={6} xxl={6}>
                        <Form.Item
                          label={translation('Failure Reported Date')}
                          name="ReportedDate"
                        >
                          <DatePicker
                            format={'YYYY-MM-DD HH:mm'}
                            placeholder={translation('Failure Reported Date')}
                            style={{ width: '100%' }}
                            disabled={true}
                          />
                        </Form.Item>
                      </Col>

                      <Col xs={24} sm={12} md={12} lg={6} xl={6} xxl={6}>
                        <Form.Item
                          name="Attachments"
                          label={translation('Attachments')}
                        >
                          <div style={{ display: 'flex', gap: '2%', flexWrap: 'wrap', width: '100%' }}>
                            <Button
                              onClick={() => handleClick('Add New Attachments')}
                              style={{ flex: 1 }}
                              disabled={formObject?.Id}
                            >
                              <CloudUploadOutlined /> Upload files
                            </Button>
                            <Button onClick={() => handleClick('View Attachments')} style={{ flex: 1 }}>
                              <EyeOutlined /> View files
                            </Button>
                          </div>
                          <Upload
                            multiple={true}
                            beforeUpload={beforeUpload}
                            onChange={(info) => fileUpload(info)}
                            action={`${API_FRACAS_MULTIPLE.ReportingSaveFile}?SiteId=${siteId}&Type=fracas&Source=Reporting`}
                            headers={{ Authorization }}
                            showUploadList={false}
                          >
                            <Button style={{ display: 'none' }} ref={myRef} className="uploadFile">
                              <UploadOutlined /> Upload
                            </Button>
                          </Upload>
                          <Drawer
                            title="Failure Report Uploaded Files"
                            open={showusecasedownloadModal}
                            width={'50%'}
                            onOk={() => setShowusecasedownloadModal(false)}
                            onClose={() => setShowusecasedownloadModal(false)}
                          >
                            <StyledTable size="small"
                              columns={UseCaseColumns}
                              dataSource={
                                formObject &&
                                  formObject.Attachments &&
                                  Array.isArray(formObject.Attachments) &&
                                  formObject.Attachments
                                  ? [...formObject.Attachments]
                                  : []
                              }
                            />
                          </Drawer>
                        </Form.Item>
                      </Col>

                      <Col xs={24} sm={12} md={12} lg={6} xl={6} xxl={6}>
                        <Form.Item
                          label={translation('Status')}
                          name="Status"
                        >
                          <Select
                            disabled={selectedKey === 'view' || (correctiveButton === true && formObject.Status === 'Analysis Completed')}
                            placeholder={translation('Select Status')}
                            onChange={onStatusChange}
                            style={{ width: '100%' }}
                          >
                            {statusList?.map((status, index) => (
                              <Option key={index} value={status.NextStatus}>
                                {status.NextStatus}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </Col>

                      <Col xs={24} sm={12} md={12} lg={6} xl={6} xxl={6}>
                        <Form.Item
                          label={translation('Reported By')}
                          name="ReportedBy"
                        >
                          <Select
                            disabled={true}
                            placeholder={translation('Select Reported By')}
                            style={{ width: '100%' }}
                          >
                            {userList?.map((user, index) => (
                              <Option key={index} value={user.Id}>
                                {user.Name}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </Col>

                      <Col xs={24} sm={12} md={12} lg={6} xl={6} xxl={6}>
                        <Form.Item
                          label={translation('Report ID')}
                          name="ReportID"
                        >
                          <Input
                            disabled={true}
                            placeholder={translation('Select Report ID')}
                            style={{ width: '100%' }}
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                    <div style={{ marginTop: '20px' }}>
                      <Collapse
                        defaultActiveKey={['1']}
                        style={{ width: '100%' }}
                        expandIcon={({ isActive }) => isActive ? <UpOutlined /> : <DownOutlined />}
                      >
                        <Panel header="Questions" key="1">
                          <Form
                            name="dynamic_form_nest_item_Analysis"
                            autoComplete="off"
                            form={QuestionRef}
                            initialValues={{ Questions }}
                            layout="vertical"
                            className="Answers_Form"
                          >
                            <div style={{ maxWidth: 800 }}>

                              <Form.List name="Questions">
                                {(fields, { add, remove }) => (
                                  <>
                                    {fields.map(({ key, name, ...restField }) => (
                                      <Row gutter={16} key={key} style={{ marginBottom: 20 }}>
                                        <Col xs={24} sm={24} md={12}>
                                          <Form.Item
                                            label="Question"
                                            {...restField}
                                            name={[name, 'QuestionId']}
                                            rules={[{ required: true, message: 'Missing Question' }]}
                                          >
                                            <Select
                                              showSearch
                                              placeholder="Question"
                                              disabled={formObject.Id}
                                              optionFilterProp="children"
                                              filterOption={(input, option) =>
                                                option?.children?.toLowerCase().includes(input.toLowerCase())
                                              }
                                            >
                                              {questionsList?.map((item, index) => (
                                                <Option key={index} value={item.Id}>
                                                  {item.Question}
                                                </Option>
                                              ))}
                                            </Select>
                                          </Form.Item>
                                        </Col>

                                        <Col xs={24} sm={24} md={11}>
                                          <Form.Item
                                            label="Answer"
                                            {...restField}
                                            name={[name, 'Answers']}
                                            rules={[{ required: true, message: 'Missing Answer' }]}
                                          >
                                            <Input
                                              disabled={formObject.Id}
                                              placeholder="Answer"
                                            />
                                          </Form.Item>
                                        </Col>


                                      </Row>
                                    ))}

                                  </>
                                )}
                              </Form.List>
                            </div>
                          </Form>
                        </Panel>
                      </Collapse>
                    </div>

                  </div>
                </Panel>
              </Collapse>
            </div>
            {(AnalysisValues_M && Array.isArray(AnalysisValues_M) && AnalysisValues_M.length > 0) ?
              <div
                style={{ display: 'flex', flexWrap: 'wrap', marginTop: '10px' }}
              >
                <Collapse
                  defaultActiveKey={['1']}
                  style={{ width: '100%' }}
                  expandIcon={({ isActive }) =>
                    isActive ? <UpOutlined /> : <DownOutlined />
                  }
                >
                  <Panel header="Analysis Details" key="1">
                    <Form
                      name="dynamic_form_nest_item_ADM"
                      autoComplete="off"
                      ref={CARef}
                      form={AnalysisRef_M}
                      initialValues={{ AnalysisValues_M: AnalysisValues_M }}
                      style={{ width: '100%' }}
                      layout="vertical"
                      className="Answers_Form"
                    >
                      <Form.List name="AnalysisValues_M">
                        {(fields, { add, remove }) => (
                          <>
                            {fields.map(({ key, name, ...restField }, index) => (
                              <div style={{ display: 'flex', flexWrap: 'initial', marginBottom: "10px" }} key={key}>
                                <Checkbox
                                  className='Failure_Checkbox'
                                  style={{ width: '3%' }}
                                  key={key}
                                  onChange={(e) => { onAnalysisCheckChange(e, key, name); }}
                                  disabled={(formObject && formObject.Status && formObject.Status === 'Closed') || selectedKey === 'view'}
                                  checked={
                                    !!selectedAnalysisDetails.find(
                                      item => item.Id === AnalysisValues_M[name]?.Id && item.Selected
                                    )
                                  }
                                />
                                <Collapse
                                  defaultActiveKey={['1']}
                                  style={{ width: '100%' }}
                                  expandIcon={({ isActive }) =>
                                    isActive ? <UpOutlined /> : <DownOutlined />
                                  }
                                  key={name}
                                >
                                  <Panel header={
                                    <span>
                                      <span style={{ fontWeight: 'bold' }}>{'UserName'}</span> :
                                      <span style={{ margin: '0px 8px' }}>
                                        {AnalysisValues_M[name].FirstName},
                                      </span>
                                      <span style={{ fontWeight: 'bold' }}>
                                        {'Department Name'}
                                      </span>{' '}
                                      :
                                      <span style={{ margin: '0px 8px' }}>
                                        {AnalysisValues_M[name].Name}
                                      </span>
                                    </span>
                                  } key="1">

                                    <Space
                                      key={key}
                                      style={{ display: 'flex' }}
                                      align="baseline"
                                    >
                                      <Row gutter={16}>
                                        <Form.Item name="Id" />

                                        <Col xs={24} sm={12} md={12} lg={6} xl={6}>
                                          <Form.Item
                                            label={translation('Analysis Start Date')}
                                            {...restField}
                                            name={[name, 'AnalysisStartDate']}
                                            rules={[
                                              {
                                                required: true,
                                                message: 'Please Select Analysis Start Date!',
                                              },
                                            ]}
                                          >
                                            <DatePicker
                                              showTime
                                              showNow={false}
                                              disabled
                                              placeholder="Select Analysis Start Date"
                                              inputReadOnly
                                              style={{ width: '100%' }}
                                              format="YYYY-MM-DD HH:mm"
                                              disabledDate={(d) => {
                                                const now = dayjs();
                                                const reportedDateValue = form2?.getFieldValue('ReportedDate');
                                                const analysisDueDateValue = form3?.getFieldValue('AnalysisDueDate');
                                                const reportedDate = reportedDateValue ? dayjs(reportedDateValue) : null;
                                                const analysisDueDate = analysisDueDateValue ? dayjs(analysisDueDateValue) : null;

                                                let minDate = now;
                                                if (reportedDate && reportedDate.isAfter(now)) {
                                                  minDate = reportedDate;
                                                }

                                                return (
                                                  !d ||
                                                  d.add(1, 'day').isBefore(minDate) ||
                                                  (analysisDueDate && d.isAfter(analysisDueDate))
                                                );
                                              }}
                                              disabledTime={(current) => {
                                                const FromTime = form2?.getFieldValue('ReportedDate');
                                                const currentTime = dayjs();
                                                if (!FromTime || !current) return {};

                                                const disabledHours = [];
                                                const disabledMinutes = [];
                                                const disabledSeconds = [];

                                                if (current.isSame(FromTime, 'day')) {
                                                  for (let i = 0; i < FromTime.hour(); i++) disabledHours.push(i);
                                                  if (current.hour() === FromTime.hour()) {
                                                    for (let i = 0; i < FromTime.minute(); i++) disabledMinutes.push(i);
                                                    if (current.minute() === FromTime.minute()) {
                                                      for (let i = 0; i < FromTime.second(); i++) disabledSeconds.push(i);
                                                    }
                                                  }
                                                }

                                                if (current.isSame(currentTime, 'day')) {
                                                  for (let i = 0; i < currentTime.hour(); i++) disabledHours.push(i);
                                                  if (current.hour() === currentTime.hour()) {
                                                    for (let i = 0; i < currentTime.minute(); i++) disabledMinutes.push(i);
                                                    if (current.minute() === currentTime.minute()) {
                                                      for (let i = 0; i < currentTime.second(); i++) disabledSeconds.push(i);
                                                    }
                                                  }
                                                }

                                                return {
                                                  disabledHours: () => disabledHours,
                                                  disabledMinutes: () => disabledMinutes,
                                                  disabledSeconds: () => disabledSeconds,
                                                };
                                              }}
                                            />
                                          </Form.Item>
                                        </Col>

                                        <Col xs={24} sm={12} md={12} lg={6} xl={6}>
                                          <Form.Item
                                            label={translation('Analysis Due Date')}
                                            {...restField}
                                            name={[name, 'AnalysisDueDate']}
                                            rules={[
                                              {
                                                required: true,
                                                message: 'Please Select Analysis Due Date',
                                              },
                                            ]}
                                          >
                                            <DatePicker
                                              showTime
                                              showNow={false}
                                              disabled
                                              placeholder="Select Analysis Due Date"
                                              inputReadOnly
                                              style={{ width: '100%' }}
                                              format="YYYY-MM-DD HH:mm"
                                              disabledDate={disabledEndDate}
                                              disabledTime={(current) => {
                                                const FromTime = form3?.getFieldValue('AnalysisStartDate');
                                                const currentTime = dayjs();
                                                if (!FromTime || !current) return {};

                                                const disabledHours = [];
                                                const disabledMinutes = [];
                                                const disabledSeconds = [];

                                                if (current.isSame(FromTime, 'day')) {
                                                  for (let i = 0; i < FromTime.hour(); i++) disabledHours.push(i);
                                                  if (current.hour() === FromTime.hour()) {
                                                    for (let i = 0; i < FromTime.minute(); i++) disabledMinutes.push(i);
                                                    if (current.minute() === FromTime.minute()) {
                                                      for (let i = 0; i < FromTime.second(); i++) disabledSeconds.push(i);
                                                    }
                                                  }
                                                }

                                                if (current.isSame(currentTime, 'day')) {
                                                  for (let i = 0; i < currentTime.hour(); i++) disabledHours.push(i);
                                                  if (current.hour() === currentTime.hour()) {
                                                    for (let i = 0; i < currentTime.minute(); i++) disabledMinutes.push(i);
                                                    if (current.minute() === currentTime.minute()) {
                                                      for (let i = 0; i < currentTime.second(); i++) disabledSeconds.push(i);
                                                    }
                                                  }
                                                }

                                                return {
                                                  disabledHours: () => disabledHours,
                                                  disabledMinutes: () => disabledMinutes,
                                                  disabledSeconds: () => disabledSeconds,
                                                };
                                              }}
                                            />
                                          </Form.Item>
                                        </Col>

                                        <Col xs={24} sm={12} md={12} lg={6} xl={6}>
                                          <Form.Item
                                            label={translation('Analysis Attachments')}
                                            {...restField}
                                            name={[name, 'AnalysisAttachments']}
                                            key={key}
                                          >
                                            <div style={{ display: 'flex', gap: '2%', flexWrap: 'wrap', width: '100%' }}>
                                              <Button
                                                onClick={() =>
                                                  existingAnalysisHandleClick(
                                                    'Add New Attachments',
                                                    Array.isArray(name) ? name.join('-') : name
                                                  )
                                                }
                                                disabled
                                              >
                                                <CloudUploadOutlined /> Upload files
                                              </Button>
                                              <Button onClick={() => existingAnalysisHandleClick('View Attachments', name)}>
                                                <EyeOutlined /> View files
                                              </Button>
                                            </div>

                                            <Upload
                                              multiple
                                              beforeUpload={(file) => {
                                                const isValidType =
                                                  file.type === 'image/jpeg' ||
                                                  file.name.endsWith('.jpg') ||
                                                  file.name.endsWith('.jpeg') ||
                                                  file.name.endsWith('.pdf') ||
                                                  file.name.endsWith('.png') ||
                                                  file.name.endsWith('.ppt') ||
                                                  file.name.endsWith('.pptx') ||
                                                  file.name.endsWith('.xls') ||
                                                  file.name.endsWith('.xlsx') ||
                                                  file.name.endsWith('.docx') ||
                                                  file.name.endsWith('.doc');
                                                if (!isValidType) message.error(`You can not upload ${file.type} files!`);

                                                const isLt2M = file.size / 1024 / 1024 < 2;
                                                if (!isLt2M) message.error('File must be smaller than 2MB!');

                                                return isValidType && isLt2M;
                                              }}
                                              onChange={(info) => analysisFileUpload(info)}
                                              action={`${API_FRACAS_MULTIPLE.ReportingSaveFile}?SiteId=${siteId}&Type=fracas&Source=Analysis`}
                                              headers={{ Authorization }}
                                              showUploadList={false}
                                            >
                                              <Button style={{ display: 'none' }} ref={myRef1} className="uploadFile">
                                                <UploadOutlined /> Upload
                                              </Button>
                                            </Upload>

                                            <Drawer
                                              title="Failure Analysis Uploaded Files"
                                              open={analysisShowusecasedownloadModalExisting}
                                              width="50%"
                                              onOk={() => setAnalysisShowusecasedownloadModalExisting(false)}
                                              onClose={() => setAnalysisShowusecasedownloadModalExisting(false)}
                                            >
                                              <StyledTable
                                                size="small"
                                                columns={AnalysisUseCaseColumns}
                                                dataSource={
                                                  AnalysisValues_M &&
                                                    AnalysisValues_M[selectedIndexAnalysis] &&
                                                    Array.isArray(AnalysisValues_M[selectedIndexAnalysis].AnalysisAttachments)
                                                    ? [...AnalysisValues_M[selectedIndexAnalysis].AnalysisAttachments]
                                                    : []
                                                }
                                              />
                                            </Drawer>
                                          </Form.Item>
                                        </Col>

                                        <Col xs={24} sm={12} md={12} lg={6} xl={6}>
                                          <Form.Item
                                            label={translation('Failure Cause')}
                                            {...restField}
                                            name={[name, 'FailureCause']}
                                          >
                                            <TextArea
                                              disabled
                                              placeholder="Input Failure Cause"
                                              style={{ width: '100%' }}
                                            />
                                          </Form.Item>
                                        </Col>

                                        <Col xs={24} sm={12} md={12} lg={6} xl={6}>
                                          <Form.Item
                                            label={translation('Contributing Factors')}
                                            {...restField}
                                            name={[name, 'ContributingFactors']}
                                          >
                                            <TextArea
                                              disabled
                                              placeholder="Input Contributing Factors"
                                              style={{ width: '100%' }}
                                            />
                                          </Form.Item>
                                        </Col>

                                        <Col xs={24} sm={12} md={12} lg={6} xl={6}>
                                          <Form.Item
                                            label={translation('Analysis Description')}
                                            {...restField}
                                            name={[name, 'AnalysisComments']}
                                          >
                                            <TextArea
                                              disabled
                                              placeholder="Input Analysis Description"
                                              style={{ width: '100%' }}
                                            />
                                          </Form.Item>
                                        </Col>
                                      </Row>

                                    </Space>


                                  </Panel>
                                </Collapse>
                              </div>
                            ))}

                          </>
                        )}
                      </Form.List>
                    </Form>
                  </Panel>
                </Collapse>
              </div>
              : null}
            {
              (ExistingCorrective_M && Array.isArray(ExistingCorrective_M) && ExistingCorrective_M.length > 0) ?
                <div
                  style={{ display: 'flex', flexWrap: 'wrap', marginTop: '10px' }}
                >
                  <Collapse
                    defaultActiveKey={['1']}
                    style={{ width: '100%' }}
                    expandIcon={({ isActive }) =>
                      isActive ? <UpOutlined /> : <DownOutlined />
                    }
                  >
                    <Panel header="Corrective Actions" key="1">
                      <div
                        style={{ display: 'flex', flexWrap: 'wrap', marginTop: '10px' }}
                      >
                        <Form
                          name="dynamic_form_nest_item_CAE"
                          autoComplete="off"
                          ref={CARef}
                          form={ExistingCorrectiveRef_M}
                          initialValues={{ ExistingCorrective_M: ExistingCorrective_M }}
                          style={{ width: '100%' }}
                          layout="vertical"
                          className="Answers_Form"
                        >
                          <Form.List name="ExistingCorrective_M">
                            {(fields, { add, remove }) => (
                              <>
                                {fields.map(({ key, name, ...restField }, index) => (
                                  <div style={{ display: 'flex', flexWrap: 'initial', marginBottom: "10px" }} key={key}>
                                    <Checkbox
                                      className='Failure_Checkbox'
                                      key={key}
                                      style={{ width: '3%' }}
                                      disabled={(formObject && formObject.Status && formObject.Status === 'Closed') || selectedKey === 'view'}
                                      onChange={(e) => { onCheckChange(e, key, name); }}
                                      checked={
                                        !!selectedCorrectiveActions.find(
                                          item => item.Id === ExistingCorrective_M[name]?.Id && item.Selected
                                        )
                                      }

                                    />
                                    <Collapse
                                      defaultActiveKey={['1']}
                                      style={{ width: '100%' }}
                                      expandIcon={({ isActive }) =>
                                        isActive ? <UpOutlined /> : <DownOutlined />
                                      }
                                      key={name}
                                    >
                                      <Panel header={
                                        <span>
                                          <span style={{ fontWeight: 'bold' }}>{'UserName'}</span> :
                                          <span style={{ margin: '0px 8px' }}>
                                            {ExistingCorrective_M[name].FirstName},
                                          </span>
                                          <span style={{ fontWeight: 'bold' }}>
                                            {'Department Name'}
                                          </span>{' '}
                                          :
                                          <span style={{ margin: '0px 8px' }}>
                                            {ExistingCorrective_M[name].Name}
                                          </span>
                                        </span>
                                      } key="1">

                                        <Space
                                          key={key}
                                          style={{ display: 'flex' }}
                                          align="baseline"
                                        >
                                          <Row gutter={16}>
                                            <Form.Item name="Id" />

                                            <Col xs={24} sm={12} md={12} lg={6} xl={6}>
                                              <Form.Item
                                                label={translation('Change Recommendations')}
                                                {...restField}
                                                name={[name, 'ChangeRecommendations']}
                                                rules={[
                                                  {
                                                    required: true,
                                                    message: 'Please Select Change Recommendations!',
                                                  },
                                                ]}
                                              >
                                                <Select
                                                  placeholder="Please Select Change Recommendations!"
                                                  style={{ width: '100%' }}
                                                  disabled
                                                >
                                                  <Option value="SECP">Software Engineering Change Proposal</Option>
                                                  <Option value="HECP">Hardware Engineering Change Proposal</Option>
                                                </Select>
                                              </Form.Item>
                                            </Col>

                                            <Col xs={24} sm={12} md={12} lg={6} xl={6}>
                                              <Form.Item
                                                label={translation('Corrective Action Type')}
                                                {...restField}
                                                name={[name, 'CorrectiveActionType']}
                                                rules={[
                                                  {
                                                    required: true,
                                                    message: 'Please Select Corrective Action Type',
                                                  },
                                                ]}
                                              >
                                                <Select
                                                  placeholder="Please Select Corrective Action Type!"
                                                  disabled
                                                  style={{ width: '100%' }}
                                                >
                                                  <Option value="Design">Design</Option>
                                                  <Option value="ShortTerm">Short Term</Option>
                                                  <Option value="LongTerm">Long Term</Option>
                                                </Select>
                                              </Form.Item>
                                            </Col>

                                            <Col xs={24} sm={12} md={12} lg={6} xl={6}>
                                              <Form.Item
                                                label={translation('Corrective Actions Attachments')}
                                                {...restField}
                                                name={[name, 'CorrectiveActionsAttachments']}
                                                key={key}
                                              >
                                                <div style={{ display: 'flex', gap: '2%', flexWrap: 'wrap', width: '100%' }}>
                                                  <Button
                                                    onClick={() =>
                                                      existingCorrectiveHandleClick(
                                                        'Add New Attachments',
                                                        Array.isArray(name) ? name.join('-') : name
                                                      )
                                                    }
                                                    disabled
                                                  >
                                                    <CloudUploadOutlined /> Upload files
                                                  </Button>

                                                  <Button onClick={() => existingCorrectiveHandleClick('View Attachments', name)}>
                                                    <EyeOutlined /> View files
                                                  </Button>
                                                </div>

                                                <Upload
                                                  multiple
                                                  beforeUpload={(file) => {
                                                    const isAllowed =
                                                      file.type === 'image/jpeg' ||
                                                      file.name.endsWith('.jpg') ||
                                                      file.name.endsWith('.jpeg') ||
                                                      file.name.endsWith('.pdf') ||
                                                      file.name.endsWith('.png') ||
                                                      file.name.endsWith('.ppt') ||
                                                      file.name.endsWith('.pptx') ||
                                                      file.name.endsWith('.xls') ||
                                                      file.name.endsWith('.xlsx') ||
                                                      file.name.endsWith('.docx') ||
                                                      file.name.endsWith('.doc');

                                                    if (!isAllowed) {
                                                      message.error(`You can not upload ${file.type} files!`);
                                                    }

                                                    const isLt2M = file.size / 1024 / 1024 < 2;
                                                    if (!isLt2M) {
                                                      message.error('File must be smaller than 2MB!');
                                                    }

                                                    return isAllowed && isLt2M;
                                                  }}
                                                  onChange={(info) => correctiveFileUpload(info, key, selectedIndex)}
                                                  action={`${API_FRACAS_MULTIPLE.ReportingSaveFile}?SiteId=${siteId}&Type=fracas&Source=CorrectiveActions`}
                                                  headers={{ Authorization }}
                                                  showUploadList={false}
                                                >
                                                  <Button style={{ display: 'none' }} ref={myRef2} className="uploadFile">
                                                    <UploadOutlined /> Upload
                                                  </Button>
                                                </Upload>

                                                <Drawer
                                                  title="Corrective Actions Uploaded Files"
                                                  open={correctiveShowusecasedownloadModalExisting}
                                                  width="50%"
                                                  onOk={() => setCorrectiveShowusecasedownloadModalExisting(false)}
                                                  onClose={() => setCorrectiveShowusecasedownloadModalExisting(false)}
                                                >
                                                  <StyledTable
                                                    size="small"
                                                    columns={CorrectiveActionsUseCaseColumns}
                                                    dataSource={
                                                      ExistingCorrective_M &&
                                                        ExistingCorrective_M[selectedIndexEC] &&
                                                        Array.isArray(ExistingCorrective_M[selectedIndexEC].CorrectiveActionsAttachments)
                                                        ? [...ExistingCorrective_M[selectedIndexEC].CorrectiveActionsAttachments]
                                                        : []
                                                    }
                                                  />
                                                </Drawer>
                                              </Form.Item>
                                            </Col>

                                            <Col xs={24} sm={12} md={12} lg={6} xl={6}>
                                              <Form.Item
                                                label={translation('Planned Corrective Actions')}
                                                {...restField}
                                                name={[name, 'PlannedCorrectiveActions']}
                                                rules={[
                                                  {
                                                    required: true,
                                                    message: 'Please Input Planned Corrective Actions!',
                                                  },
                                                ]}
                                              >
                                                <TextArea
                                                  disabled
                                                  placeholder="Input Planned Corrective Actions"
                                                  style={{ width: '100%' }}
                                                />
                                              </Form.Item>
                                            </Col>

                                            <Col xs={24} sm={12} md={12} lg={6} xl={6}>
                                              <Form.Item
                                                label={translation('Implemented Corrective Actions')}
                                                {...restField}
                                                name={[name, 'ImplementedCorrectiveActions']}
                                                rules={[
                                                  {
                                                    required: true,
                                                    message: 'Please Input Implemented Corrective Actions!',
                                                  },
                                                ]}
                                              >
                                                <TextArea
                                                  disabled
                                                  placeholder="Input Implemented Corrective Actions"
                                                  style={{ width: '100%' }}
                                                />
                                              </Form.Item>
                                            </Col>

                                            <Col xs={24} sm={12} md={12} lg={6} xl={6}>
                                              <Form.Item
                                                label={translation('Verification and Validation field remarks')}
                                                {...restField}
                                                name={[name, 'VerificationAndValidationFieldRemarks']}
                                              >
                                                <TextArea
                                                  disabled
                                                  placeholder="Input Verification and Validation field remarks"
                                                  style={{ width: '100%' }}
                                                />
                                              </Form.Item>
                                            </Col>
                                          </Row>
                                        </Space>

                                      </Panel>
                                    </Collapse>
                                  </div>
                                )
                                )}
                              </>
                            )}
                          </Form.List>
                        </Form>
                      </div>
                    </Panel>
                  </Collapse>
                </div>
                : null}
            <Form.Item
              label="Remarks"
              name='Remarks'
            >
              <TextArea
                disabled={(formObject && formObject.Status && formObject.Status === 'Closed') || selectedKey === 'view'}
                placeholder="Please Enter Remarks"
              />
            </Form.Item>

            <div
              style={{
                display: 'flex',
                justifyContent: 'right',
                paddingTop: '1%'
              }}
            >
              <Form.Item>
                <Button type="primary" style={{ marginRight: 8 }} htmlType="submit" disabled={(correctiveButton && correctiveButton === true) || selectedKey === 'view'}>
                  Submit
                </Button>
              </Form.Item>
              <Form.Item>
                <Button key={'back'} style={{ marginRight: 8 }} onClick={onCancel} disabled={selectedKey === 'view'}>
                  Cancel
                </Button>
              </Form.Item>
            </div>
          </Form>
        </TabPane>
      </Tabs>

      <Modal
        open={treeVisible}
        width={800}
        height={800}
        closable
        title={translation('Equipment')}
        onCancel={() => setTreeVisible(false)}
        footer={[
          <Button key="back" onClick={onModalCancel}>
            Cancel
          </Button>
        ]}
      >
        <HierarchyModal
          checkedArray={checkedValue || null}
          treeData={equipmentList && equipmentList !== undefined && Object.values(equipmentList)}
          Key="Rule"
          handleDropdownChange={hierarchyDropdownChange}
        />
      </Modal>
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    currentTimeZone: state.LayoutReducer.currentTimeZone,
    themeValue: state.ThemeReducer,
    userProfile: state.LayoutReducer.loggedInProfile,
    translationCache: state.TranslationReducer.translationCache,
  };
};
export default connect(mapStateToProps)(ManagerActions);